import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(main)/blog/blog-list-client.tsx");
